export const BASE_URL: string | undefined = process.env.REACT_APP_BASE_URL;
export const BASE_URL_LOGOS: string | undefined = process.env.REACT_APP_LOGOS;
